import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/game-center-container.module.scss";
import {ExternalAd} from "../../../core/components/ad/external-ad/external-ad";
import {DBA} from "../../../core/app/consts";

export const GameCenterContainerExternalAd = observer(({controller}) => {
  const {device, state} = controller;
  const {isSmallView} = device
  const {shouldRenderAd, userCountryId, adConfig, adMock} = state

  const adProps = {
    countryId: userCountryId,
    webPage: DBA.PAGE.match,
    isSmallView,
    controller,
    isMock: adMock,
  }

  const externalAdProps = {
    ...adProps,
    config: adConfig,
    className: classNames(styles.external_ad, {[styles.small_view]: isSmallView}),
  }

  return shouldRenderAd ? <ExternalAd {...externalAdProps}/> : null
})
